var _rect, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.841797,
    y: 0.862183,
    width: 95.1313,
    height: 95.1313,
    rx: 20.357,
    fill: "#5E1B0C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.381 71.0645C33.3035 71.0645 20.8613 59.7818 19.0369 45.1988C18.7821 43.1624 20.4704 41.4902 22.5227 41.4902H74.2392C76.2915 41.4902 77.9798 43.1624 77.725 45.1988C75.9006 59.7818 63.4584 71.0645 48.381 71.0645Z",
    fill: "#F8F7F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4082 24.8946C36.191 24.8946 25.4978 30.2059 19.6237 38.1465C18.9959 38.9952 18.81 40.1043 19.2881 41.0455C22.2426 46.8621 33.2996 55.3417 48.4082 55.3417C63.6833 55.3417 74.817 47.3602 77.6231 41.0076C78.0332 40.0791 77.8356 39.0201 77.234 38.2025C71.3688 30.2309 60.6541 24.8946 48.4082 24.8946Z",
    fill: "#FE6533"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5419,
    cy: 40.1191,
    r: 10.2391,
    fill: "#F8F7F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/Insights.506f8d8cb562032f339513d4168e5992.svg";
export { ForwardRef as ReactComponent };